<!-- <li class="panel"> -->
<div class="controparte">
	<div>
		<p class="col-sm-2">
			<button (click)="emitEntity(titolo)" class="btn btn-primary associa"
				type="submit">Allega</button>
		</p>
		<h4 class="titolo col-sm-4">N. {{titolo.numero}} del
			{{titolo.anno}}</h4>
		<p class="col-sm-2">
			<strong>{{titolo.tipoTitoloEsecutivo?.label}}</strong>
		</p>
		<p class="col-sm-2">
			Valore: <strong>{{titolo.valore | euro}}</strong>
		</p>
		<p class="col-sm-2">
			Iscrizione: <strong>{{titolo.dataIscrizione |
				date:'dd/MM/yyyy' }}</strong>
		</p>
	</div>
</div>
<!-- </li> -->
